import { Grid, Skeleton, Typography } from '@mui/material'
import { GridListItem } from 'components'
import { useFormContext } from 'react-hook-form'

import { useLoadOrderProductCommission } from 'modules/orders/hooks'
import BigNumber from 'bignumber.js'
import { useMemo } from 'react'
import { formatCurrency, isDivision60User, useDebounce } from 'utils'

export const ItemCommission = (props: any) => {
  const { item } = props

  const { watch } = useFormContext()
  const canSeeCommission = isDivision60User(watch('seller')?.division)

  const sellerId = watch('seller')?.id

  const diffPrice = useMemo(() => {
    const priceBase = item.currentPrice || item.defaultPrice
    const diffPercent = BigNumber(item.salePrice)
      .div(priceBase || 100)
      .toNumber()

    const additionDecimal =
      diffPercent > 1 ? BigNumber(diffPercent).minus(1) : 0
    const discountDecimal =
      diffPercent < 1 ? BigNumber(1).minus(diffPercent) : 0

    const additionPercent = BigNumber(additionDecimal).times(100).toNumber()
    const discountPercent = BigNumber(discountDecimal).times(100).toNumber()

    return { additionPercent, discountPercent }
  }, [item.currentPrice, item.defaultPrice, item.salePrice])

  const additionPercentDeb = useDebounce(diffPrice.additionPercent, 500)
  const discountPercentDeb = useDebounce(diffPrice.discountPercent, 500)

  const { data, isFetching } = useLoadOrderProductCommission({
    additionPercent: additionPercentDeb,
    discountPercent: discountPercentDeb,
    productId: item?.id || item?.product?.id,
    sellerId
  })

  const commissionValue = useMemo(
    () =>
      BigNumber(data?.data || '0')
        .times(0.01)
        .times(item.salePrice)
        .times(item.quantity)
        .toNumber(),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [data?.data, item.quantity]
  )

  if (!canSeeCommission) return null

  return (
    <>
      <Grid item xs={12}>
        <Typography variant="h6">Comissão</Typography>
      </Grid>
      <Grid item xs={12} container>
        <GridListItem
          key={'2'}
          label={'Comissão'}
          value={`${formatCurrency(commissionValue)} (${
            Number(data?.data).toFixed(2) || 0
          }%)`}
          RenderValue={isFetching ? <Skeleton width={130} height={21} /> : null}
        />
      </Grid>
    </>
  )
}
